export default "__VITE_PUBLIC_ASSET__84f83604__"